export const ADD_TO_BAG_EVENT_NAME = 'addToBag';
export const GUEST_BAG_ITEMS_LOCAL_STORAGE_KEY = 'guestBagItems';
